import views from './views';
/*
Archivo de configuración donde se asocia una acción [key] con el nombre [valor]
Los valores que asignemos simplemente son nombres cortos de las pantallas para que la app las use internamente,
Las navegaciones no se realizan en base a paths completos si no a nombres cortos
*/

//BLOQUES DE RUTAS
//  1→ AGENTE
//  2→ ACCESO B2B PARA CLIENTE DESDE SMS o EMAIL DE CONTINUE ENVIADO POR EL AGENTE
//  3→ ACCESO B2C PARA CLIENTE DIRECTO
//  4→ CLIENTE

const routes = {
	loginAgent: 'loginAgent',
	dashboard: 'dashboard',

	continue: 'continue',
	loadTarget: 'loadTarget',

	bmw: 'bmw',
	rastreator: 'rastreator',

	loginClient: 'loginClient',
	autolanding: 'autolanding',
	upsertProduct: 'upsertProduct',

	simulationData: 'simulationData',
	simulation: 'simulation',

	clientData: 'clientData',

	pbc: 'pbc',
	health: 'health',

	bankAccount: 'bankAccount',

	identityBiometricSteps: 'identityBiometricSteps',
	identityBiometricSelect: 'identityBiometricSelect',
	identityBiometricUpsert: 'identityBiometricUpsert',
	identityBiometric: 'identityBiometric',
	identityBiometricFinished: 'identityBiometricFinished',
	IdentityBiometricAttach: 'IdentityBiometricAttach',
	identityBiometricExtraDocs: 'identityBiometricExtraDocs',

	activateProduct: 'activateProduct',

	signatureSteps: 'signatureSteps',
	signatureRead: 'signatureRead',
	signatureContract: 'signatureContract',

	productCreationFinished: 'productCreationFinished',

	cannotConfirm: 'cannotConfirm',
};

export default routes;

export const routing = {
	koReset: {
		koReset: (nav, agentIdentifier) => {
			navigate(nav, routes.loginClient, {
				clearItems: ['internalStep'],
				queryParams: {
					from: agentIdentifier !== 'allianz' ? agentIdentifier : '',
				},
			});
		},
	},
	loginAgent: {
		next: (nav) => {
			navigate(nav, routes.dashboard, { handleRedirection: true });
		},
	},
	dashboard: {
		nextNewVinculation: (nav, vinculationId, clientId, simulationId) => {
			navigate(nav, routes.simulationDataAgent, {
				routeParams: { vinculationId, clientId, simulationId },
			});
		},
	},
	simulationDataAgent: {
		next: (nav) => {
			navigate(nav, routes.simulationAgent);
		},
		back: (goBack) => {
			navigateBack(goBack);
		},
	},
	simulationAgent: {
		next: (nav) => {
			navigate(nav, routes.clientDataAgent);
		},
		back: (nav) => {
			navigate(nav, routes.clientDataAgent);
		},
	},
	clientDataAgent: {
		next: (nav) => {
			navigate(nav, routes.followUp);
		},
		back: (nav) => {
			navigate(nav, routes.simulationDataAgent);
		},
	},
	continue: {
		next: (nav) => {
			navigate(nav, routes.loadTarget, {
				clearItems: ['uniqueIdentifier', 't'],
				handleRedirection: true,
			});
		},
		back: (goBack) => {
			navigateBack(goBack);
		},
	},
	loadTarget: {
		next: (nav, route, params) => {
			navigate(nav, route, params);
		},
	},
	personalized: {
		next: (nav, from) => {
			navigate(nav, routes.loginClient, {
				queryParams: {
					from: from,
				},
			});
		},
	},
	loginClient: {
		next: (nav) => {
			navigate(nav, routes.autolanding, {
				clearItems: ['from', 't', 'simulationStep'],
			});
		},
	},
	autolanding: {
		next: (nav) => {
			navigate(nav, routes.upsertProduct);
		},
		reLogin: (nav) => {
			navigate(nav, routes.loginClient);
		},
		ko: (nav) => {
			navigate(nav, routes.cannotConfirm, {
				queryParams: {
					from: 'CALL',
				},
			});
		},
		contact: (nav) => {
			navigate(nav, routes.cannotConfirm, {
				queryParams: {
					from: 'HEADER_CONTACT',
				},
			});
		},
	},
	upsertProduct: {
		next: (nav, targetId) => {
			navigate(nav, routes.simulationData, {
				routeParams: { targetId },
			});
		},
	},
	simulationData: {
		next: (nav) => {
			navigate(nav, routes.simulation, {
				clearItems: ['internalStep'],
			});
		},
		ko: (nav) => {
			navigate(nav, routes.cannotConfirm, {
				queryParams: {
					from: 'SIMULATION_DETAILS',
				},
			});
		},
	},
	simulation: {
		next: (nav, isB2B) => {
			isB2B
				? navigate(nav, routes.pbc)
				: navigate(nav, routes.clientData, { clearItems: ['internalStep'] });
		},
		returnToActivation: (nav) => {
			navigate(nav, routes.activateProduct, { clearItems: ['editMode'] });
		},
		back: (goBack) => {
			navigateBack(goBack);
		},
		contact: (nav) => {
			navigate(nav, routes.cannotConfirm, {
				queryParams: {
					from: 'TARIFICATION',
				},
			});
		},
	},
	clientData: {
		next: (nav) => {
			navigate(nav, routes.identityBiometricSteps);
		},
		ko: (nav) => {
			navigate(nav, routes.cannotConfirm, {
				queryParams: {
					from: 'PRIVACITY',
				},
			});
		},
		koOtherOrigin: (nav) => {
			navigate(nav, routes.cannotConfirm, {
				queryParams: {
					from: 'PBC_OTHER_ORIGIN',
				},
			});
		},
		back: (goBack) => {
			navigateBack(goBack);
		},
	},
	pbc: {
		next: (nav) => {
			navigate(nav, routes.health);
		},
		ko: (nav, reason = 'PBC') => {
			navigate(nav, routes.cannotConfirm, {
				queryParams: {
					from: reason,
				},
			});
		},
		back: (goBack) => {
			navigateBack(goBack);
		},
	},
	health: {
		next: (nav) => {
			navigate(nav, routes.bankAccount);
		},
		ko: (nav, reason = 'SALUD') => {
			navigate(nav, routes.cannotConfirm, {
				queryParams: {
					from: reason,
				},
			});
		},
		back: (goBack) => {
			navigateBack(goBack);
		},
	},
	identityBiometricSteps: {
		next: (nav) => {
			if (views.identityBiometrics.steps.selectDocumentCountry) {
				navigate(nav, routes.identityBiometricSelect, {
					routeParams: { selectType: 'documentCountry' },
				});
			} else if (views.identityBiometrics.steps.selectDocumentType.include) {
				navigate(nav, routes.identityBiometricSelect, {
					routeParams: { selectType: 'documentType' },
				});
			} else {
				navigate(nav, routes.identityBiometricUpsert);
			}
		},
		nextAlreadyAdded: (nav) => {
			navigate(nav, routes.bankAccount);
		},
		back: (goBack) => {
			navigateBack(goBack);
		},
	},
	identityBiometricSelect: {
		next: (nav, prevStep) => {
			if (views.identityBiometrics.steps.selectDocumentType && prevStep !== 'documentType') {
				navigate(nav, routes.identityBiometricSelect, {
					routeParams: { selectType: 'documentType' },
				});
			} else {
				navigate(nav, routes.identityBiometricUpsert);
			}
		},
		back: (goBack) => {
			navigateBack(goBack);
		},
	},
	identityBiometricUpsert: {
		nextAlreadyAdded: (nav) => {
			navigate(nav, routes.bankAccount);
		},
		nextAddNew: (nav) => {
			if (views.identityBiometrics.steps.provider === 'alice') {
				navigate(nav, routes.identityBiometric);
			} else {
				navigate(nav, routes.IdentityBiometricAttach);
			}
		},
		back: (goBack) => {
			navigateBack(goBack);
		},
	},
	identityBiometric: {
		next: (nav) => {
			if (views.identityBiometrics.steps.addExtraDocuments) {
				navigate(nav, routes.identityBiometricExtraDocs);
			} else {
				navigate(nav, routes.bankAccount);
			}
		},
		modifyBenef: (nav) => {
			navigate(nav, routes.clientData);
		},
		modifyDNI: (nav) => {
			navigate(nav, routes.identityBiometricSteps);
		},
		ko: (nav) => {
			navigate(nav, routes.cannotConfirm, {
				queryParams: {
					from: 'DNI',
				},
			});
		},
		koFace: (nav) => {
			navigate(nav, routes.cannotConfirm, {
				queryParams: {
					from: 'DNI_FACE',
				},
			});
		},
		back: (goBack) => {
			navigateBack(goBack);
		},
	},
	identityBiometricAttach: {
		next: (nav) => {
			if (views.identityBiometrics.steps.addExtraDocuments) {
				navigate(nav, routes.identityBiometricExtraDocs);
			} else {
				navigate(nav, routes.bankAccount);
			}
		},
		back: (goBack) => {
			navigateBack(goBack);
		},
	},
	identityBiometricExtraDocs: {
		next: (nav) => {
			navigate(nav, routes.bankAccount);
		},
		nextNoNeeded: (nav) => {
			navigate(nav, routes.bankAccount);
		},
		nextAlreadyAdded: (nav) => {
			navigate(nav, routes.bankAccount);
		},
		back: (goBack) => {
			navigateBack(goBack);
		},
	},
	bankAccount: {
		next: (nav) => {
			navigate(nav, routes.activateProduct);
		},
		ko: (nav) => {
			navigate(nav, routes.cannotConfirm, {
				queryParams: {
					from: 'NOTOWNER_CHARGEACCOUNT',
				},
			});
		},
		back: (goBack) => {
			navigateBack(goBack);
		},
	},
	activateProduct: {
		nextStep2: (nav) => {
			navigate(nav, routes.simulation, {
				queryParams: { internalStep: 2 },
			});
		},
		next: (nav, envelopeId) => {
			navigate(nav, routes.signatureSteps, {
				clearItems: ['internalStep'],
				mode: 'replace',
				routeParams: { envelopeId },
			});
		},
		koRetarificate: (nav) => {
			navigate(nav, routes.simulation, {
				queryParams: { editMode: true, internalStep: 2 },
			});
		},
		koReviewData: (nav) => {
			navigate(nav, routes.simulationData, {
				clearItems: ['internalStep'],
			});
		},
		koReviewCapital: (nav) => {
			navigate(nav, routes.simulation, {
				queryParams: { internalStep: 1 },
			});
		},
		back: (goBack) => {
			navigateBack(goBack);
		},
		contact: (nav) => {
			navigate(nav, routes.cannotConfirm, {
				queryParams: {
					from: 'PREEMISSION',
				},
			});
		},
		contactBlockages: (nav) => {
			navigate(nav, routes.cannotConfirm, {
				queryParams: {
					from: 'PREEMISSION_BLOCKAGES',
				},
			});
		},
	},
	signatureSteps: {
		next: (nav) => {
			navigate(nav, routes.signatureContract);
		},
		back: (goBack) => {
			navigateBack(goBack);
		},
	},
	signatureRead: {
		next: (nav) => {
			navigate(nav, routes.signatureContract);
		},
		back: (goBack) => {
			navigateBack(goBack);
		},
	},
	signatureContract: {
		next: (nav) => {
			navigate(nav, routes.productCreationFinished);
		},
		ko: (nav) => {
			navigate(nav, routes.cannotConfirm, {
				queryParams: {
					from: 'SIGN_CONTRACT',
				},
			});
		},
		back: (goBack) => {
			navigateBack(goBack);
		},
	},
	productCreationFinished: {},
	cannotConfirm: {
		back: (goBack) => {
			navigateBack(goBack);
		},
	},
	header: {
		ko: (nav) => {
			navigate(nav, routes.cannotConfirm, {
				queryParams: {
					from: 'CALL',
				},
			});
		},
		back: (nav) => {
			navigate(nav, routes.dashboard);
		},
	},
	footer: {
		nextPrivacity: (nav) => {
			navigate(nav, routes.faq);
		},
		nextConditions: (nav) => {
			navigate(nav, routes.faq);
		},
		nextFaq: (nav) => {
			navigate(nav, routes.faq);
		},
	},
};

const navigate = (nav, ruta, params = {}) => {
	logNavigation(ruta);
	nav(ruta, params);
};

const navigateBack = (goBack) => {
	logNavigation('BACK');
	goBack();
};

const logNavigation = (ruta) => {
	console.log(`🚀 NAVIGATING TO ${ruta}`);
};
